import { render, staticRenderFns } from "./yangPrice.vue?vue&type=template&id=cfa295b6&scoped=true&"
import script from "./yangPrice.vue?vue&type=script&lang=js&"
export * from "./yangPrice.vue?vue&type=script&lang=js&"
import style0 from "./yangPrice.vue?vue&type=style&index=0&id=cfa295b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa295b6",
  null
  
)

export default component.exports